import { render, staticRenderFns } from "./CardRoomTablet.vue?vue&type=template&id=2dfc52cc&scoped=true"
import script from "./CardRoomTablet.vue?vue&type=script&lang=js"
export * from "./CardRoomTablet.vue?vue&type=script&lang=js"
import style0 from "./CardRoomTablet.vue?vue&type=style&index=0&id=2dfc52cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc52cc",
  null
  
)

export default component.exports